// extracted by mini-css-extract-plugin
export default {"skipButton":"SkipFlatNodeButton_skipButton__wRegC"};